import React from 'react';

// components
import { GuideConceptContainer } from '../guide.styled';

export const GuideConcept = ({}) => {
    return <GuideConceptContainer id='concept'></GuideConceptContainer>;
};
